import type { BranchVersion } from "~/entities/branch-version/types";
import axiosInstance from "~/shared/api/axios-instance";

interface BranchVersionResponse {
  id: number;
  branch_uid: string;
  name: string;
  description: string;
  created_at: number;
  valid_from?: string;
  valid_until?: string;
  is_active: boolean;
  has_been_active?: boolean;
}

export const fetchBranchVersions = async (branchUid: string): Promise<BranchVersion[]> => {
  const { data } = await axiosInstance.get<BranchVersionResponse[]>(
    `branches/${branchUid}/versions/`,
  );

  return data
    .map((v) => ({
      id: v.id,
      branchUid: v.branch_uid,
      name: v.name,
      description: v.description,
      createdAt: v.created_at,
      validFrom: v.valid_from,
      validTo: v.valid_until,
      isActive: v.is_active,
      hasBeenActive: v.has_been_active ?? false,
    }))
    .sort((a, b) => b.createdAt - a.createdAt);
};
